"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _errorHandlerUtility = _interopRequireDefault(require("./errorHandlerUtility"));
var _SpinnerErrorMessage = _interopRequireDefault(require("../SpinnerErrorMessage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    _errorHandlerUtility.default.report(JSON.stringify({
      'message': 'Error caught by ErrorBoundary',
      error,
      errorInfo
    }));
  }
  render() {
    if (this.state.hasError) {
      // Render any custom fallback UI
      return /*#__PURE__*/_react.default.createElement(_SpinnerErrorMessage.default, {
        error: "Error fetching form data!"
      });
    }
    return this.props.children;
  }
}
var _default = exports.default = ErrorBoundary;